import * as ImagePicker from 'expo-image-picker';
import { Platform } from 'react-native';
import * as DocumentPicker from 'expo-document-picker';
import * as FileSystem from 'expo-file-system';

export const PDF_MIME_TYPE = 'application/pdf';
export const IMAGE_MIME_TYPE = 'image/jpeg';

export const prependMetadata = (base64, type) => {
  return `data:${type};base64,${base64}`;
};

export const prependJpegMetadataImage = (base64) => {
  return prependMetadata(base64, IMAGE_MIME_TYPE);
};

const handleMobileDevices = async (result) => {
  try {
    if (!result || !result.assets || !result.assets[0] || !result.assets[0].uri) {
      throw new Error('Invalid file URI');
    }

    const uri = result.assets[0].uri;
    const base64 = await FileSystem.readAsStringAsync(uri, {
      encoding: FileSystem.EncodingType.Base64,
    });

    return base64;
  } catch (error) {
    console.error('Error converting file to base64:', error);
    return result; // Return the original result in case of failure
  }
};

export const pickImage = async (callback, isAddReceipt = false) => {
  try {
    const result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.All,
      allowsEditing: isAddReceipt ? false : true,
      quality: 1,
      base64: true,
    });

    if (result.canceled) {
      return;
    }

    if (Platform.OS === 'web') {
      result.assets[0].base64 = result.assets[0].uri;
    } else {
      result.assets[0].base64 = prependJpegMetadataImage(result.assets[0].base64);
    }

    callback(result);
  } catch (error) {
    console.error('Error picking image:', error);
  }
};

export const pickFile = async (callback) => {
  try {
    // Allow both PDFs and images
    const result = await DocumentPicker.getDocumentAsync({
      type: ['image/*', PDF_MIME_TYPE],
      copyToCacheDirectory: true,
      multiple: false,
    });

    if (Platform.OS === 'web') {
      result.assets[0].base64 = result.assets[0].uri;
    } else {
      const base64 = await handleMobileDevices(result);
      result.assets[0].base64 = prependMetadata(base64, result.assets[0].mimeType);
    }

    if (!result.canceled) {
      callback(result);
    }
  } catch (error) {
    console.error('Error picking file:', error);
  }
};
